<template>
  <div>
    <div>
      <DropDown v-model="invoice" :options="INVOICES" optionLabel="name" @change="dataInput = invoice.data" :filter="true" filterPlaceholder="Sök faktura" placeholder="Välj faktura för redigering, varning du ska veta vad du gör" />
      <Button label="Uppdatera faktura" icon="pi pi-plus" @click="updateInvoice()" />
      <pre v-if="dataOutput">
        {{ dataOutput | toJSON }}
      </pre>
    </div>
    <div v-if="dataInput">
      <json-editor :data-input="dataInput" @data-output="(data) => (dataOutput = data)"> </json-editor>
    </div>
  </div>
</template>

<script>
import JsonEditor from '@kassaila/vue-json-editor'
import Button from 'primevue/button'
import DropDown from 'primevue/dropdown'

import { mapGetters } from 'vuex'

export default {
  name: 'InvoiceEdit',
  components: {
    JsonEditor,
    Button,
    DropDown
  },
  data () {
    return {
      invoice: {},
      dataInput: null,
      dataOutput: null
    }
  },
  async mounted () {
    await this.$store.dispatch('GET_ACTIVE_INVOICES')
  },
  computed: {
    ...mapGetters(['INVOICES'])
  },
  methods: {
    async updateInvoice () {
      await this.$store.dispatch('UPDATE_INVOICE_DATA', {
        id: this.invoice.id,
        data: this.dataOutput
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/InvoiceEdit.vue